import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse, HttpHeaders } from '@angular/common/http';
import { ConfigService } from 'ngx-envconfig';
import { Agentstorage } from 'src/app/models/agentstorage';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class CmhistoriqueService {

  private findallhistoriquemaster = this.configService.get('ipMS') + 'historiquecarte/findallhistoriquemastercard';
  private motifmaster = this.configService.get('ipMS') + 'carte/operationmastercard';


  private findallhistorique = this.configService.get('ipMS') + 'carte/findalltransaction';


  authorization: string = " ";
  caissierid: string = " ";


  constructor(private http: HttpClient, private configService: ConfigService) {
    let u = new Agentstorage();
    u = JSON.parse(localStorage.getItem('curentuser'));

    if (u != null) {
      this.authorization = u.token;
      this.caissierid = u.agent.agentid;
    }
  }

  getAllHistoriqueCarteabonnement(): Observable<HttpResponse<any>> {
    return this.http.get(this.findallhistoriquemaster,
      {
        observe: 'response',
        headers: new HttpHeaders({ 'Access-Control-Allow-Origin': '*' })
          .set("content-Type", "application/json")
          .set("Authorization", this.authorization)
      });
  }


  getAllHistoriqueMaster(id : string): Observable<HttpResponse<any>> {
    return this.http.get(this.findallhistorique+'/'+id,
      {
        observe: 'response',
        headers: new HttpHeaders({ 'Access-Control-Allow-Origin': '*' })
          .set("content-Type", "application/json")
          .set("Authorization", this.authorization)
      });
  }



  public post(value: any): Observable<HttpResponse<any>> {
    console.log(JSON.stringify(value));
    return this.http.post(this.motifmaster, JSON.stringify(value), {
      observe: 'response',
      headers: new HttpHeaders({ 'Access-Control-Allow-Origin': '*' })
        .set("content-Type", "application/json")
        .set("Authorization", this.authorization)
    });
  }
}
